import { t } from 'i18next';
import { showDate2, showDateFull } from 'src/constants';

const Invoice2 = ({ data }) => {
  return (
    <div
      id="invoice2"
      style={{
        width: '210mm',
        minHeight: '297mm',
        display: 'none',
        flexDirection: 'column',
        alignItems: 'center',
        fontFamily: 'Arial, sans-serif',
      }}
    >
      <section
        style={{
          width: '189mm',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'flex-start',
        }}
      >
        <div style={{ width: '63mm' }}>
          <img src="/logo.jpeg" alt="" style={{ width: '100%', height: '100%' }} />
        </div>
        <div style={{ marginTop: '18mm', paddingRight: '10mm' }}>
          <h4>
            {t('invoice2.itemNumber')} {String(data.subOrderNumber).padStart(4, '0')}
          </h4>
          <h4>
            {t('invoice2.place')}{' '}
            <span
              style={{
                borderBottom: '1px dotted black',
                paddingBottom: '2mm',
              }}
            >
              {showDate2(data.createdAt)}
            </span>
          </h4>
        </div>
      </section>
      <section
        style={{
          width: '189mm',
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        <h2>
          <span
            style={{
              borderBottom: '0.5mm solid black',
              paddingBottom: '2.5mm',
            }}
          >
            {t('invoice2.heading')}{' '}
          </span>
          {t('invoice2.numberPrefix')} {data.orderNumber}
        </h2>
      </section>
      <table
        style={{
          width: '150mm',
          borderCollapse: 'collapse',
          marginTop: '5mm',
        }}
      >
        <thead>
          <tr style={{ backgroundColor: '#c6daff' }}>
            <th
              style={{
                width: '84mm',
                borderLeft: '0.25mm solid black',
                borderTop: '0.25mm solid black',
                padding: '0 1.25mm 3.5mm 1.25mm',
                textAlign: 'center',
              }}
            >
              {t('invoice2.customer')}
            </th>
            <th
              style={{
                width: '63mm',
                borderLeft: '0.25mm solid black',
                borderTop: '0.25mm solid black',
                padding: '0 1.25mm 3.5mm 1.25mm',
                textAlign: 'center',
              }}
            >
              {t('invoice2.description')}
            </th>
            <th
              style={{
                width: '31.5mm',
                borderLeft: '0.25mm solid black',
                borderTop: '0.25mm solid black',
                padding: '0 1.25mm 3.5mm 1.25mm',
                textAlign: 'center',
              }}
            >
              {t('invoice2.dosage')}
            </th>
            <th
              style={{
                width: '31.5mm',
                border: '0.25mm solid black',
                padding: '0 1.25mm 3.5mm 1.25mm',
                textAlign: 'center',
              }}
            >
              {t('invoice2.volume')}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr style={{ height: '12.5mm' }}>
            <td
              style={{
                borderLeft: '0.25mm solid black',
                borderTop: '0.25mm solid black',
                fontSize: '1.25em',
                padding: '0 1mm 3.5mm 1mm',
                textAlign: 'center',
              }}
            >
              {data.customerInfo.firstName + ' ' + data.customerInfo.lastName}
            </td>
            <td
              style={{
                borderLeft: '0.25mm solid black',
                borderTop: '0.25mm solid black',
                padding: '0 1mm 3.5mm 1mm',
                textAlign: 'center',
                fontSize: '1.25em',
              }}
            >
              {data.description ? data.description : '-'}
            </td>
            <td
              style={{
                borderLeft: '0.25mm solid black',
                borderTop: '0.25mm solid black',
                padding: '0 1mm 3.5mm 1mm',
                textAlign: 'center',
                fontSize: '1.25em',
              }}
            >
              {data.dosage}
            </td>
            <td
              style={{
                border: '0.25mm solid black',
                borderTop: 'none',
                padding: '0 1mm 3.5mm 1mm',
                textAlign: 'center',
                fontSize: '1.25em',
              }}
            >
              {data.volumeOfConcrete}m³
            </td>
          </tr>
          <tr style={{ height: '12.5mm' }}>
            <td
              style={{
                borderLeft: '0.25mm solid black',
                borderTop: '0.25mm solid black',
                padding: '1mm',
                alignContent: 'flex-start',
              }}
            >
              <h4 style={{ margin: 0 }}>{t('invoice2.deliveryDate')}</h4>
            </td>
            <td
              style={{
                borderLeft: '0.25mm solid black',
                borderTop: '0.25mm solid black',
                padding: '0 1mm 3.5mm 1mm',
                textAlign: 'center',
                fontSize: '1.25em',
              }}
            >
              {showDateFull(data.deliveryDate)}
            </td>
            <td
              style={{
                borderLeft: '0.25mm solid black',
                borderTop: '0.25mm solid black',
                padding: '1mm',
                alignContent: 'flex-start',
              }}
            >
              <h4 style={{ margin: 0 }}>{t('invoice2.hour')}</h4>
            </td>
            <td
              style={{
                border: '0.25mm solid black',
                borderTop: 'none',
                borderBottom: 'none',
                padding: '0 1mm 3.5mm 1mm',
                textAlign: 'center',
                fontSize: '1.25em',
              }}
            >
              {t(`labels.${data.timeOfDelivery}`)}
            </td>
          </tr>
          <tr style={{ height: '12.5mm' }}>
            <td
              style={{
                border: '0.25mm solid black',
                padding: '1mm',
                alignContent: 'flex-start',
              }}
            >
              <h4 style={{ margin: 0 }}>{t('invoice2.telephone')}</h4>
            </td>
            <td
              style={{
                border: '0.25mm solid black',
                borderLeft: 'none',
                padding: '0 1mm 3.5mm 1mm',
                textAlign: 'center',
                fontSize: '1.25em',
              }}
              colSpan={3}
            >
              {data.customerInfo.phoneNumber ? data.customerInfo.phoneNumber : '-'}
            </td>
          </tr>
        </tbody>
      </table>
      <section style={{ display: 'flex', width: '150mm', minHeight: '12.5mm' }}>
        <div
          style={{
            width: '33.6mm',
            border: '0.25mm solid black',
            borderTop: 'none',
            padding: '1.25mm',
            alignContent: 'flex-start',
          }}
        >
          <h4 style={{ margin: 0 }}>{t('invoice2.address')}</h4>
        </div>
        <div
          style={{
            width: '155.4mm',
            border: '0.25mm solid black',
            borderTop: 'none',
            borderLeft: 'none',
            padding: '0 1mm 3.5mm 1mm',
            textAlign: 'center',
            fontSize: '1.25em',
          }}
        >
          {data.streetNumber
            ? data.streetNumber +
              ' ' +
              data.streetAddress +
              ' ' +
              data.municipality +
              ', ' +
              data.city +
              ', ' +
              data.country
            : '-'}
        </div>
      </section>
    </div>
  );
};

export default Invoice2;
